import styled from 'styled-components';

import { StyledVersionedRouterLink } from 'components/Link/StyledVersionedRouterLink';
import { colors, cssBreakpoints, gutterWidth, h4Text } from 'theme/theme';

export const MyAccountMobileDropdownHolder = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 101;
  overflow-y: scroll;
  background: white;
  box-shadow: -2px 0 4px rgb(0 0 0 / 10%);

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const MyAccountMobileDropdownHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 ${gutterWidth / 2}px;
  border-bottom: 1px solid ${colors.selectionGrey};
`;

export const MyDropdownMobileHeaderTitle = styled.h4`
  ${h4Text};
  color: ${colors.brandBlue};
  margin: 0;
`;

export const MyAccountMobileDropdownBody = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MyAccountMobileDropdownSection = styled.section({});

export const MyAccountMobileDropdownSectionTitle = styled.h5`
  text-transform: uppercase;
  width: 100%;
  margin: 0;
  height: 64px;
  color: ${colors.mediumContentGrey};
  background: ${colors.backgroundBlue};
  font-size: 16px;
  font-weight: normal;
  padding-left: 20px;
  display: flex;
  align-items: center;
`;

export const MyAccountMobileDropdownLink = styled(StyledVersionedRouterLink)`
  height: 64px;
  font-size: 16px;
  font-weight: normal;
  padding-left: 20px;
  display: flex;
  align-items: center;
  color: ${colors.mediumContentGrey};
  text-decoration: none;
`;

export const MyAccountMobileDropdownFooter = styled.footer`
  margin: 20px;
`;
